module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture17-b646b1663a0952f3a2f0990627e870cb.jpg";